import Purchase from "./Purchase";

export default Purchase;
